import React, { useCallback, useMemo, Dispatch, SetStateAction } from 'react'
import styled from '@emotion/styled'

import Card from '../../components/common/Card'
import Text from '../../components/common/Text'
import PointLabel from '../../components/common/PointLabel'
import {
  productRedeem,
  useClaimShopReward,
  useGetProductDetail,
} from '../../services/shop/shop-query'
import { useGetUser, useGetUserCoin } from '../../services/user/user-query'
import Button from '../../components/common/Button'
import { useRouter } from '../../utils/helper'
import { useTranslation } from 'react-i18next'
interface RightCardProps {
  setCurrentStep: Dispatch<SetStateAction<number>>
}

const RightCard = styled(Card)`
  flex: 1;
  padding: 32px 24px 40px 24px;
`
const PointLayout = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
`
const FlexFlow = styled.div`
  display: flex;
  flex-direction: row;
`
const FlexChild = styled.div`
  flex: 1;
`
const ButtonPanel = styled(FlexFlow)`
  justify-content: center;
  margin-top: 40px;
`

const RightCardComp = (props: RightCardProps) => {
  const { data: user } = useGetUser()
  const { setCurrentStep } = props
  const { query } = useRouter()
  const { data: userCoin } = useGetUserCoin()
  const { mutate: claimReward } = useClaimShopReward()
  const { t } = useTranslation()
  const { data: productDetail, isLoading } = useGetProductDetail(query.rewardId)
  const { title, thumbnailImage, specialCoin, remain, description, expireDate } =
    productDetail || {}

  const differentPoint = useMemo(() => {
    return ((userCoin || 0) - (specialCoin || 0)).toLocaleString(undefined, {
      maximumFractionDigits: 2,
    })
  }, [specialCoin, userCoin])

  const canRedeem = useMemo(() => {
    return Number(differentPoint) < 0
      ? false
      : true && productRedeem({ userCoin, specialCoin, remain, expireDate })
  }, [differentPoint, userCoin, specialCoin, remain, expireDate])

  const onClaimRewardSuccess = useCallback(() => {
    setCurrentStep(2)
  }, [setCurrentStep])
  const onConfirmClick = useCallback(() => {
    claimReward(
      { userId: user?.userId, productId: query.rewardId },
      { onSuccess: onClaimRewardSuccess },
    )
  }, [user, query, claimReward, onClaimRewardSuccess])

  return (
    <RightCard>
      <PointLayout>
        <Text size={22}>{t('shopRewardClaim.currentUserPoint')}</Text>
        <FlexChild />
        <PointLabel label={userCoin} />
      </PointLayout>

      {/* <div style={{ minHeight: 300 }}>
        <Text size={22} type="Bold">
          เลือกธนาคารเพื่อชำระส่วนต่าง
        </Text>
        <Radio
          options={[
            { label: 'ชำระผ่าน SCB Easy', value: 1, image: ScbImage },
            { label: 'ชำระผ่าน KBank', value: 2, image: KbankImage },
          ]}
        />
      </div> */}

      <FlexFlow>
        <Text size={22}>{t('shopRewardClaim.pointOfProduct')}</Text>
        <FlexChild />
        <Text size={22} type="Bold">
          {productDetail?.specialCoin.toLocaleString(undefined, { maximumFractionDigits: 2 })}{' '}
          {t('app.point')}
        </Text>
      </FlexFlow>

      <FlexFlow>
        <Text size={22}>{t('shopRewardClaim.pointLeft')}</Text>
        <FlexChild />
        <Text size={22} type="Bold">
          {differentPoint} {t('app.point')}
        </Text>
      </FlexFlow>

      <ButtonPanel>
        <Button disabled={!canRedeem} onClick={onConfirmClick}>
          {t('shopRewardClaim.claimButtonText')}
        </Button>
      </ButtonPanel>
    </RightCard>
  )
}

export default RightCardComp
